import { Component, Inject, Input, OnInit, Optional } from '@angular/core';

@Component({
    selector: 'lib-gung-barcode',
    templateUrl: './gung-barcode.component.html',
    styleUrl: './gung-barcode.component.scss',
    standalone: false
})
export class GungBarcodeComponent implements OnInit {
  @Input() code: string;

  @Input() width: number = 300;

  @Input() height: number = 100;

  @Input() showCode: boolean = false;

  public barcodeImageUrl: string = '';

  constructor(
    @Optional()
    @Inject('environment')
    protected environment: { [s: string]: any }
  ) { }

  ngOnInit() {
    this.barcodeImageUrl = `${this.environment.backendUrl}/gung-resource/barcode/code128/${this.width}x${this.height}/${this.code}`;
  }
}
